import React from "react";

const FormInput = ({
  label,
  type = "text",
  id,
  placeholder,
  rightContent,
  errorMessage,
  className = "",
  labelClassName = "",
  inputClassName = "",
  ...props
}) => {
  return (
    <div className={className}>
      {label && (
        <label
          className={`leading-5  text-black ${labelClassName}`}
          htmlFor={id}
        >
          {label}
        </label>
      )}

      <div className="relative">
        <input
          id={id}
          type={type}
          placeholder={placeholder}
          className={`w-full rounded-lg  bg-transparent px-2.5 py-[9.5px] text-black placeholder:text-[#938A96] outline-none ${
            rightContent ? "pr-24" : ""
          } ${inputClassName}`}
          {...props}
        />

        {rightContent ? (
          <div className="absolute inset-y-0 right-7 top-3 flex items-center gap-2">
            {rightContent}
          </div>
        ) : null}
      </div>

      {errorMessage ? (
        <p className=" text-sm  text-[#C62828]">
          {errorMessage}
        </p>
      ) : null}
    </div>
  );
};

export default FormInput;
